import api from './api';


const unwrapRows = (response) => {
  const payload = response.data;
  if (Array.isArray(payload)) {
    return { rows: payload, count: payload.length };
  }
  return {
    rows: payload.results || [],
    count: payload.count || 0,
  };
};

export const getMarketplaceWarehouses = async () => {
  const response = await api.get('/admin/warehouse/warehouses/');
  return unwrapRows(response);
};

export const createMarketplaceWarehouse = async (payload) => {
  const response = await api.post('/admin/warehouse/warehouses/', payload);
  return response.data;
};

export const updateMarketplaceWarehouse = async (sid, payload) => {
  const response = await api.patch(`/admin/warehouse/warehouses/${sid}/`, payload);
  return response.data;
};

export const getMarketplaceRateCards = async () => {
  const response = await api.get('/admin/warehouse/rate-cards/');
  return unwrapRows(response);
};

export const createMarketplaceRateCard = async (payload) => {
  const response = await api.post('/admin/warehouse/rate-cards/', payload);
  return response.data;
};

export const updateMarketplaceRateCard = async (sid, payload) => {
  const response = await api.patch(`/admin/warehouse/rate-cards/${sid}/`, payload);
  return response.data;
};

export const getMarketplaceStorageAccounts = async () => {
  const response = await api.get('/admin/warehouse/storage-accounts/');
  return unwrapRows(response);
};

export const createMarketplaceStorageAccount = async (payload) => {
  const response = await api.post('/admin/warehouse/storage-accounts/', payload);
  return response.data;
};

export const getMarketplaceInboundShipments = async () => {
  const response = await api.get('/admin/warehouse/inbound-shipments/');
  return unwrapRows(response);
};

export const getMarketplaceInboundShipment = async (sid) => {
  const response = await api.get(`/admin/warehouse/inbound-shipments/${sid}/`);
  return response.data;
};

export const updateMarketplaceInboundShipment = async (sid, payload) => {
  const response = await api.patch(`/admin/warehouse/inbound-shipments/${sid}/`, payload);
  return response.data;
};

export const getMarketplaceWarehouseLocations = async () => {
  const response = await api.get('/admin/warehouse/locations/');
  return unwrapRows(response);
};

export const receiveMarketplaceInboundShipment = async (sid, payload) => {
  const response = await api.post(`/admin/warehouse/inbound-shipments/${sid}/receive/`, payload);
  return response.data;
};

export const scanMarketplaceWarehouseLabel = async (labelCode) => {
  const response = await api.get('/admin/warehouse/inbound-shipments/scan-label/', {
    params: { label_code: labelCode },
  });
  return response.data;
};

export const getMarketplaceInventoryLots = async () => {
  const response = await api.get('/admin/warehouse/inventory-lots/');
  return unwrapRows(response);
};

export const getMarketplaceCharges = async () => {
  const response = await api.get('/admin/warehouse/charges/');
  return unwrapRows(response);
};

export const getMarketplaceInvoices = async () => {
  const response = await api.get('/admin/warehouse/invoices/');
  return unwrapRows(response);
};

export const getMarketplaceFulfillments = async () => {
  const response = await api.get('/admin/warehouse/fulfillments/');
  return unwrapRows(response);
};

export const createMarketplaceFulfillment = async (payload) => {
  const response = await api.post('/admin/warehouse/fulfillments/', payload);
  return response.data;
};

export const completeMarketplaceFulfillment = async (sid, payload) => {
  const response = await api.post(`/admin/warehouse/fulfillments/${sid}/complete/`, payload);
  return response.data;
};

export const getMarketplacePackagingMaterials = async () => {
  const response = await api.get('/admin/packaging-materials/', { params: { is_active: true } });
  return unwrapRows(response);
};

export const generateMarketplaceStorageCharges = async () => {
  const response = await api.post('/admin/warehouse/inbound-shipments/generate-storage-charges/');
  return response.data;
};

export const issueMarketplaceInvoice = async (storageAccountSid) => {
  const response = await api.post('/admin/warehouse/invoices/issue/', {
    storage_account_sid: storageAccountSid,
  });
  return response.data;
};

export const refreshMarketplaceOverdueAccounts = async () => {
  const response = await api.post('/admin/warehouse/storage-accounts/refresh-overdue/');
  return response.data;
};

export const restoreMarketplaceStorageAccount = async (sid) => {
  const response = await api.post(`/admin/warehouse/storage-accounts/${sid}/restore-after-settlement/`);
  return response.data;
};

export const getMarketplaceStorageAgreements = async () => {
  const response = await api.get('/admin/warehouse/storage-agreements/');
  return unwrapRows(response);
};

export const createMarketplaceStorageAgreement = async (payload) => {
  const response = await api.post('/admin/warehouse/storage-agreements/', payload);
  return response.data;
};

export const getMarketplaceExitRequests = async () => {
  const response = await api.get('/admin/warehouse/exit-requests/');
  return unwrapRows(response);
};

export const approveMarketplaceExitRequest = async (sid, payload) => {
  const response = await api.post(`/admin/warehouse/exit-requests/${sid}/approve/`, payload);
  return response.data;
};

export const getMarketplaceDispositionCases = async () => {
  const response = await api.get('/admin/warehouse/disposition-cases/');
  return unwrapRows(response);
};

export const completeMarketplaceLegalReview = async (sid, payload) => {
  const response = await api.post(`/admin/warehouse/disposition-cases/${sid}/complete-legal-review/`, payload);
  return response.data;
};

export const approveMarketplaceDisposition = async (sid) => {
  const response = await api.post(`/admin/warehouse/disposition-cases/${sid}/approve/`);
  return response.data;
};

export const executeMarketplaceDisposition = async (sid) => {
  const response = await api.post(`/admin/warehouse/disposition-cases/${sid}/execute/`);
  return response.data;
};

export const recordMarketplaceDispositionNotice = async (sid, payload) => {
  const response = await api.post(`/admin/warehouse/disposition-cases/${sid}/record-notice/`, payload);
  return response.data;
};
